import React from 'react';

import { RegistrationRedirect } from 'components/registration/redirect';

export const RegistrationRedirectPage: React.FC = () => {
    return <RegistrationRedirect />;
};
